var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgFrbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0F6B6B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 16) scale(1) translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.6,
    y: 5,
    width: 3,
    height: 6,
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.8 27.4 12.8V23a2 2 0 0 1-2 2H12.6c-1.6 2.4-3.3 3.6-5.2 3.9.9-1.2 1.3-2.5 1.3-3.9H6.6a2 2 0 0 1-2-2V12.8Z",
    fill: "#FAF7F2",
    stroke: "#FAF7F2",
    strokeWidth: 2.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 25V16.9a2.9 2.9 0 0 1 5.8 0V25Z",
    fill: "#C8102E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrbIcon);
export default __webpack_public_path__ + "static/media/frb-icon.9b6a94c04ab63e808fa283714bbb012f.svg";
export { ForwardRef as ReactComponent };